module.exports = __webpack_public_path__ + "static/as-a-man-thinketh-bb86a9345b481a20d7f3463c17f85183.jpg";